// components/News/NewsfeedIndia.jsx
import React, { useEffect, useState } from 'react';

export default function NewsfeedIndia() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const fetchRSS = async () => {
      try {
        const res = await fetch(
          'https://api.rss2json.com/v1/api.json?rss_url=https://economictimes.indiatimes.com/markets/stocks/news/rssfeeds/2146842.cms'

        );
        const data = await res.json();
        setItems(data.items.slice(0, 6));
      } catch (error) {
        console.error('Error loading Indian market feed:', error);
      }
    };

    fetchRSS();
  }, []);

  return (
    <div className="space-y-4 text-sm text-gray-200">
      {items.length === 0 ? (
        <p className="text-gray-500 italic">Loading Indian market news...</p>
      ) : (
        items.map((item, index) => (
          <div key={index} className="border-b border-gray-700 pb-2">
            <a
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-400 font-semibold hover:underline"
            >
              {item.title}
            </a>
            <p className="text-xs text-gray-400 mt-1">
              {new Date(item.pubDate).toLocaleString()}
            </p>
          </div>
        ))
      )}
    </div>
  );
}
